export const siteSettings = {
  name: "Crypto Nest Pro",
  link: "https://cryptonestpro.net",
  email: "support@cryptonestpro.net",
  appLink: "https://app.cryptonestpro.net",
};
